import { LuQuote } from 'react-icons/lu'
import { Reveal } from '@/components/ui/Reveal'

interface QuoteBandProps {
  quote: string
  author: string
  role: string
}

/** A single client quote, used near the end of a page to build trust before the enquiry banner. */
export const QuoteBand = ({ quote, author, role }: QuoteBandProps) => (
  <section className="border-t border-green-100 bg-green-50 py-14 sm:py-16 lg:py-20">
    <Reveal>
      <figure className="mx-auto max-w-3xl px-6 text-center">
        <span
          aria-hidden="true"
          className="mx-auto mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-white text-green-700"
        >
          <LuQuote className="h-5 w-5" />
        </span>
        <blockquote className="font-display text-2xl leading-snug tracking-tight text-green-950 sm:text-3xl">
          “{quote}”
        </blockquote>
        <figcaption className="mt-6 flex items-center justify-center gap-3 text-sm">
          <span aria-hidden="true" className="h-px w-8 bg-gold-500" />
          <span className="font-medium text-green-900">{author}</span>
          <span className="text-green-800">{role}</span>
          <span aria-hidden="true" className="h-px w-8 bg-gold-500" />
        </figcaption>
      </figure>
    </Reveal>
  </section>
)
